import CommonHelper from 'helpers/CommonHelper';
import styled from 'styled-components';

import e_logo from '../../../../assets/E_Logo.svg';
import generate_img from '../../../../assets/generate.svg';
import heart_img from '../../../../assets/heart_outlined.svg';
import token_girl_img from '../../../../assets/token_modal_bg.webp';
import voice_img from '../../../../assets/voice_outlined.svg';

const ImageModalSection: React.FC = () => {

  return (
    <Root>
      <ImageSection url={token_girl_img} />
      <BottomSection>
        <Logo />
        <TokenInfoSection>
          <PremiumDescription>Tokens benefits:</PremiumDescription>
          <OfferIconsSection>
            <IconSection>
              <IconWrapper>
                <Icon src={heart_img} />
                <ComingSoonTip>Coming soon</ComingSoonTip>
              </IconWrapper>
              <IconDescription>Create<br /> AI girlfriends</IconDescription>
            </IconSection>
            <IconSection>
              <>
                <Icon src={generate_img} />
              </>
              <IconDescription>AI image<br /> generation</IconDescription>
            </IconSection>
            <IconSection>
              <IconWrapper>
                <Icon src={voice_img} />
                <ComingSoonTip>Coming soon</ComingSoonTip>
              </IconWrapper>
              <IconDescription>Voice<br /> messages</IconDescription>
            </IconSection>
          </OfferIconsSection>
        </TokenInfoSection>
      </BottomSection>
    </Root>
  );
};

export default ImageModalSection;

const Root = styled.div`
  width: 48%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px 0 0 12px;
`;

const ImageSection = styled.div<{ url: string }>`
  height: 100%;
  background-color: #000000;
  background-size: cover;
  background-position: center;
  background-image: ${({ url }) => `url(${CommonHelper.getEroplayCdnUrl(url)})`};
  border-radius: 12px 0 0 0;
  transition: opacity 0.5s ease-in-out;
`;

const IconSection = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100px;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  `;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

const IconDescription = styled.p`
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  color: #FFFFFF;
`;

const ComingSoonTip = styled.p`
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  background-clip: text;
  color: transparent;
  font-family: Nunito Sans;
  font-size: 10px;
  font-weight: 400;
  line-height: 18px;
`;

const BottomSection = styled.div`
  height: 40%;
  background-color: #131313;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 0 12px;
`;

const Logo = styled.div`
  background-image: url(${CommonHelper.getEroplayCdnUrl(e_logo)});
  background-size: contain;
  background-repeat: no-repeat;
  width: 60%;
  height: 38px;
  position: absolute;
  top: -35%;
  left: 28%;
`;

const PremiumDescription = styled.span`
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  background-clip: text;
  color: transparent;
  margin-bottom: 18px;
}`;

const TokenInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 32px 32px 43px 32px;
  margin-top: auto;
`;

const OfferIconsSection = styled.div`
  display: flex;
  gap: 8px;
`;
